import React from "react";
import {
    Avatar,
    Box,
    Chip,
    Grid,
    Typography,
    useTheme
} from "@mui/material";
//@ts-ignore
import candidatePhoto from "../../../assets/images/others/jpg-3.png";

const CandidateHeader: React.FC = () => {
    const theme = useTheme();

    return (
        <>
            <Grid container spacing={3} alignItems="center">
                {/* Photo */}
                <Grid size={{ xs: 12 }}>
                    <Box display="flex" justifyContent="center">
                        <Avatar
                            src={candidatePhoto}
                            alt="Jean-Philippe Guibert"
                            sx={{
                                width: { xs: 150, md: 200 },
                                height: { xs: 150, md: 200 },
                                border: `3px solid ${theme.palette.primary.main}`,
                                boxShadow: 2
                            }}
                        />
                    </Box>
                </Grid>
                {/* Texte */}
                <Grid size={{ xs: 12 }}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1
                        }}
                    >
                        <Typography
                            variant="h5"
                            fontWeight={700}
                            color="primary"
                        >
                            Jean-Philippe GUIBERT
                        </Typography>

                        <Typography
                            variant="subtitle1"
                            color="text.secondary"
                        >
                            Tête de liste de{" "}
                            <Box component="span" fontWeight={700}>
                                Vivre la démocratie 2026
                            </Box>
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

export default CandidateHeader;
